module.exports = __webpack_public_path__ + "static/media/headbanner4.af40593f.mp4";